import { motion } from "framer-motion";
import { Trophy, MapPin, Crown, TrendingUp } from "lucide-react";

export default function LeaderSection() {
  return (
    <section
      data-testid="leader-section"
      className="py-24 md:py-32 bg-black relative overflow-hidden"
    >
      {/* Ambient glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-gradient-to-b from-[#B76E79]/8 to-transparent blur-[120px] pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[300px] h-[300px] bg-gradient-to-tl from-[#B76E79]/5 to-transparent blur-[100px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-16 md:mb-20"
        >
          <div className="inline-flex items-center gap-2 mb-6">
            <Crown size={16} className="text-[#B76E79]" />
            <p className="text-xs font-semibold uppercase tracking-[0.25em] bg-clip-text text-transparent bg-gradient-to-r from-[#B76E79] to-[#D68B8B]">
              Sektör Lideri
            </p>
            <Crown size={16} className="text-[#B76E79]" />
          </div>
          <h2
            data-testid="leader-headline"
            className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tighter text-white mb-6 max-w-3xl mx-auto leading-tight"
          >
            Bursa ve Görükle Bölgesinde
            <br />
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#B76E79] to-[#D68B8B]">
              Sektörde Lider Firma
            </span>
          </h2>
          <p className="text-base text-white/60 max-w-2xl mx-auto leading-relaxed">
            Yılların deneyimi, binlerce mutlu danışan ve sürekli gelişen hizmet kalitesiyle
            Bursa'nın güzellik sektöründe fark yaratıyoruz.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {[
            {
              icon: Trophy,
              title: "Sektör Liderliği",
              desc: "Bursa ve Görükle bölgesinde güzellik alanında öncü ve lider kuruluş",
            },
            {
              icon: MapPin,
              title: "Stratejik Konum",
              desc: "Görükle'nin kalbinde, kolay ulaşılabilir premium güzellik merkezi",
            },
            {
              icon: TrendingUp,
              title: "Sürekli Gelişim",
              desc: "Sektördeki en son trendleri ve teknolojileri yakından takip ediyoruz",
            },
            {
              icon: Crown,
              title: "Premium Kalite",
              desc: "En yüksek kalite standartlarında hizmet ve müşteri deneyimi sunuyoruz",
            },
          ].map((item, i) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              data-testid={`leader-feature-${i}`}
              className="p-8 border border-white/10 backdrop-blur-sm bg-white/[0.02] hover:bg-white/[0.05] transition-all duration-500 group"
            >
              <div className="w-12 h-12 flex items-center justify-center gold-bg mb-5 group-hover:scale-110 transition-transform duration-300">
                <item.icon size={20} className="text-white" />
              </div>
              <h3 className="text-base font-bold tracking-tight text-white mb-2">
                {item.title}
              </h3>
              <p className="text-sm leading-relaxed text-white/60">
                {item.desc}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Bottom bar */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.5 }}
          className="mt-12 md:mt-16 pt-8 md:pt-10 border-t border-white/10 grid grid-cols-2 md:flex md:flex-row items-center justify-center gap-6 md:gap-16"
        >
          {[
            { num: "#1", label: "Görükle'de" },
            { num: "10.000+", label: "Mutlu Danışan" },
            { num: "5+", label: "Yıllık Tecrübe" },
            { num: "%100", label: "Güvenilirlik" },
          ].map((s) => (
            <div key={s.label} className="text-center">
              <div className="text-xl sm:text-2xl md:text-3xl font-bold tracking-tighter text-[#B76E79]">
                {s.num}
              </div>
              <div className="text-xs text-white/50 mt-1 uppercase tracking-widest">
                {s.label}
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
